var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { createAsyncThunk } from '@reduxjs/toolkit';
import qs from 'qs';
import api from './config';
export const fetchPreference = createAsyncThunk('preference/login', (args, thunkAPI) => __awaiter(void 0, void 0, void 0, function* () {
    var _a;
    try {
        const data = qs.stringify({
            username: args.username,
            password: args.password,
            tipo_usuario: window.env.REACT_APP_APIUSERTYPE,
            renew: '1',
            expires_in: window.env.REACT_APP_APIUSERTYPE,
        });
        const response = yield api(null, 'application/x-www-form-urlencoded').post(`API/EndPoint002.php?code=get_jwt_uf&tipo_usuario=${window.env.REACT_APP_APIUSERTYPE}`, data);
        return response.data;
    }
    catch (error) {
        const err = error;
        return thunkAPI.rejectWithValue((_a = err.response) === null || _a === void 0 ? void 0 : _a.data);
    }
}));
export const fetchCarteiraList = createAsyncThunk('preference/carteiraList', (args, thunkAPI) => __awaiter(void 0, void 0, void 0, function* () {
    var _b, _c, _d;
    const data = JSON.stringify({
        abas: ['ListaCarteiras'],
    });
    const token = (_c = (_b = thunkAPI.getState().preference) === null || _b === void 0 ? void 0 : _b.token.value) !== null && _c !== void 0 ? _c : '';
    try {
        const response = yield api(token).post(`API/EndPoint002.php?code=${window.env.REACT_APP_APICODE}&service=CarregaCoreExtratoWhitelabel001`, data);
        return response.data;
    }
    catch (error) {
        const err = error;
        return thunkAPI.rejectWithValue((_d = err.response) === null || _d === void 0 ? void 0 : _d.data);
    }
}));
export const fetchPreferenceWhitelabel = createAsyncThunk('preference/preferenceWhitelabel', (args, thunkAPI) => __awaiter(void 0, void 0, void 0, function* () {
    var _e, _f, _g;
    const token = (_f = (_e = thunkAPI.getState().preference) === null || _e === void 0 ? void 0 : _e.token.value) !== null && _f !== void 0 ? _f : '';
    try {
        const response = yield api(token).get(`API/EndPoint002.php?code=${window.env.REACT_APP_APICODE}&service=CarregaPreferenceWhitelabel`);
        return response.data;
    }
    catch (error) {
        const err = error;
        return thunkAPI.rejectWithValue((_g = err.response) === null || _g === void 0 ? void 0 : _g.data);
    }
}));
export const sendAnalyticsData = createAsyncThunk('preference/sendAnalyticsData', (link, thunkAPI) => __awaiter(void 0, void 0, void 0, function* () {
    var _h, _j;
    const token = (_j = (_h = thunkAPI.getState().preference) === null || _h === void 0 ? void 0 : _h.token.value) !== null && _j !== void 0 ? _j : '';
    const data = qs.stringify({
        URL: link,
    });
    yield api(token, 'application/x-www-form-urlencoded').post(`API/EndPoint002.php?code=${window.env.REACT_APP_APICODE}&service=RegistraPageviewWhitelabel001`, data);
}));
export const changePassword = createAsyncThunk('preference/changePassword', (password, thunkAPI) => __awaiter(void 0, void 0, void 0, function* () {
    var _k, _l, _m;
    const token = (_l = (_k = thunkAPI.getState().preference) === null || _k === void 0 ? void 0 : _k.token.value) !== null && _l !== void 0 ? _l : '';
    const data = qs.stringify({
        password,
    });
    try {
        yield api(token, 'application/x-www-form-urlencoded').post(`API/EndPoint002.php?code=${window.env.REACT_APP_APICODE}&service=RecadastraSenha001`, data);
    }
    catch (error) {
        const err = error;
        return thunkAPI.rejectWithValue((_m = err.response) === null || _m === void 0 ? void 0 : _m.data);
    }
}));
